import React, { useState } from 'react';
import { Icon, Typography } from 'ck-ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from '../../NewsLetter/PopupSignup.module.scss';
import { SignUpForm } from '../../NewsLetter/SignUpForm';
import { TermsAndPrivacyLinks } from '../../TermsAndPrivacyLinks';

const LandingSignUp = ({ source, successMessage }) => {
  const [hasSignedUp, setHasSignedUp] = useState(false);
  const handleSignedUp = () => setHasSignedUp(true);
  return (
    <div className="home-section">
      <div className="container">
        <div className="columns">
          <div className="column">
            {hasSignedUp ? (
              <>
                <Typography variant="heading5" align="centered" uppercase className={styles.largeMarginTop}>THANK YOU FOR SIGNING UP!</Typography>
                <Typography
                  className={classnames(
                    'is-flex',
                    'is-flex-centered',
                    styles.largeMarginTop,
                    styles.tick
                  )}
                >
                  <Icon color="secondary" name="check" />
                </Typography>
                <Typography
                  variant="heading7"
                  align="centered"
                  uppercase
                  className={classnames(styles.largeMarginTop, styles.largeMarginBottom, styles.successMessage)}
                  dangerouslySetInnerHTML={{ __html: successMessage }}
                />
              </>
            ) : (
              <SignUpForm
                hasNameSection
                source={source}
                onSubmitSuccess={handleSignedUp}
              />
            )}
            <TermsAndPrivacyLinks />
          </div>
        </div>
      </div>
    </div>
  );
};

LandingSignUp.propTypes = {
  source: PropTypes.string,
  successMessage: PropTypes.string
};

LandingSignUp.defaultProps = {
  source: null,
  successMessage: 'CONGRATULATIONS, YOU ARE IN!',
};

export { LandingSignUp };
